import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import 'bootstrap-icons/font/bootstrap-icons.css';
import CookieConsentProvider from './components/CookieConsentWrapper';
import Home from './pages/Home';
import WhatWeDo from './pages/WhatWeDo';
import PeoplePurpose from './pages/PeoplePurpose';
import BrandVault from './pages/BrandVault';
import Clients from './pages/Clients';
import WorksWithUs from './pages/WorksWithUs';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CadillacEscalade from './pages/Clients/CadillacEscalade';
import Auto from './pages/Clients/Auto';
import Tech from './pages/Clients/Tech';
import Specialty from './pages/Clients/Specialty';
import CPG from './pages/Clients/CPG';
import Healthcare from './pages/Clients/Healthcare';
import NotFound from './pages/404';
import Careers from './pages/Careers';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Legal from './pages/Legal';
import AiFactsPage from './pages/AIFacts';
import SubstackEmbedPage from './pages/SubstackEmbed';
import BlogPage from './pages/BlogIndex';
import BlogIndex from './pages/BlogIndex'; 
import BlogPostPage from './pages/BlogPostPage';

let gtmInitialized = false;

// The function to initialize GTM
const loadGTM = () => {
  if (!gtmInitialized) {
    console.log('GTM initialization triggered by CookieConsentProvider.');
    TagManager.initialize({
      gtmId: 'GTM-T3SGPW22'
    });
    gtmInitialized = true;
  }
};

function App() {
  return (
    // Wrap your entire Router with the CookieConsentProvider
    <CookieConsentProvider onGtmConsentAccepted={loadGTM}>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/what-we-do" element={<WhatWeDo />} />
          <Route path="/people-purpose" element={<PeoplePurpose />} />
          <Route path="/brand-vault" element={<BrandVault />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/clients/cadillacescalade" element={<CadillacEscalade />} />
          <Route path="/clients/Auto" element={<Auto />} />
          <Route path="/clients/ce-tech" element={<Tech />} />
          <Route path="/clients/specialty" element={<Specialty />} />
          <Route path="/clients/cpg" element={<CPG />} />
          <Route path="/clients/healthcare" element={<Healthcare />} />
          <Route path="/work-with-us" element={<WorksWithUs />} />
          <Route path="/blogs" element={<BlogPage />} />
          <Route path="/ai-facts" element={<AiFactsPage />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/brandacumen-substack" element={<SubstackEmbedPage />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </Router>
    </CookieConsentProvider>
  );
}

export default App;